import React from 'react';

import { type TAvatarBlock } from '@wp-block-builder/blocks/Avatar';
import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style: { padding: string }): TAvatarBlock => ({
  id: generateRandomBlockId(),
  type: 'Avatar',
  style: {
    fontFamily: 'inherit',
    fontWeight: 'normal',
    textAlign: 'left',
    ...style,
  },
  props: {
    size: 64,
    imageUrl: null,
    shape: 'circle',
    fallbackText: 'OK',
    fallbackColor: null,
  },
  sectionProps: {},
});

const DEFAULT_PADDING = '16px 16px 16px 16px';

export default defineBlockButton<TAvatarBlock>({
  label: 'Avatar',
  icon: <BlockTypeIcon type="Avatar" />,
  defaultBlock: () => getDefaultProps({ padding: DEFAULT_PADDING }),
  defaultContainerBlock: () => getDefaultProps({ padding: DEFAULT_PADDING }),
  defaultColumnBlock: () => getDefaultProps({ padding: '0px 0px 0px 0px' }),
});
